import createActionTypes from './createActionTypes';

export const namespace = 'FLYER_GIBS';

export const types = createActionTypes(namespace, ['RESET']);

export const resetFlyerGibs = (resetState) => ({
  type: types.RESET,
  payload: { resetState },
});
